import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";

import { RequirePermission } from "@/components/RequirePermission";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

const AdminAccessPage = lazy(() =>
  import("./AdminAccessPage").then((m) => ({ default: m.AdminAccessPage }))
);

function Loader() {
  return <div style={{ padding: 20, color: "var(--text-muted)", fontSize: 14 }}>Loading...</div>;
}

export const adminAccessFeature: FeatureModule = {
  id: "admin-access",
  // Access leaves primary nav — the page is reached via the Settings slot.
  navItems: [],
  routes: [
    {
      path: ROUTES.settingsAccess,
      element: (
        <RequirePermission perm="rbac.manage" redirectTo={ROUTES.home}>
          <Suspense fallback={<Loader />}>
            <AdminAccessPage />
          </Suspense>
        </RequirePermission>
      ),
    },
    // Redirect old URL so any bookmarked or linked /admin/access keeps working.
    {
      path: "/admin/access",
      element: <Navigate to={ROUTES.settingsAccess} replace />,
    },
  ],
};
